module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/triangle-183412141f5841d4e00f9c1f133f3c77.svg&quot;;"